// extracted by mini-css-extract-plugin
export default {"Filter":"doD4nl1W0FKB0YSoiXAG"};